<template>
  <app-list
    :goToSingleItem="goToSingleItem"
    :items="filteredItems"
    :loading="vehiclesIsLoading"
    :error="vehiclesError"
    :pageNumber="pageNumber"
    :updatePageNumber="SET_PAGE_NUMBER"
    :displayMenu=true
  >
    <template v-slot:action-buttons>
      <v-btn
        :to="{name: 'add-vehicle'}"
        class="text-none"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Add a Vehicle
      </v-btn>
    </template>
    <template v-slot:search-box>
      <v-row>
        <v-col cols="2">
          <v-autocomplete
            :items="years"
            :value="selectedYear"
            @input="selectYear"
            solo
            hide-no-data
            hide-details
            label="Year"
            placeholder="Type to Search"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            :items="makes"
            :value="selectedMake"
            @input="selectMake"
            :disabled="!selectedYear"
            solo
            hide-no-data
            hide-details
            label="Make"
            placeholder="Type to Search"
            dense
          ></v-autocomplete>
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            :items="models"
            :value="selectedModel"
            @input="selectModel"
            :disabled="!(selectedYear && selectedMake)"
            solo
            hide-no-data
            hide-details
            label="Model"
            placeholder="Type to Search"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            :items="engineSizes"
            :value="selectedEngineSize"
            @input="selectEngineSize"
            :disabled="!(selectedYear && selectedMake && selectedModel)"
            solo
            hide-no-data
            hide-details
            label="Engine Size"
            placeholder="Type to Search"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="1">
          <v-btn
            color="error"
            @click="clearSearch"
          >
            Clear
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <template v-slot:menu-options="{ item }">
      <v-list-item
        @click="$router.push({name:'edit-vehicle', params: {id:item.id}})"
        dense
      >
        <v-list-item-title>Edit</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item
        @click="deleteClicked(item.id)"
        dense
      >
        <v-list-item-title class="red--text">Delete</v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:app-item="{ item }">
      <div class="pb-2 text-body-1 black--text"><span>Year: </span><span class="font-weight-bold">{{ item.year }}</span></div>
      <div class="pb-2 text-body-1 black--text"><span>Make: </span><span class="font-weight-bold">{{ item.make }}</span></div>
      <div class="pb-2 text-body-1 black--text"><span>Model: </span><span class="font-weight-bold">{{ item.model }}</span></div>
      <div class="pb-2 text-body-1 black--text"><span>Engine Size: </span><span class="font-weight-bold">{{ item.engine_size }}</span></div>
    </template>
  </app-list>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "@/store/modules/vehicles";
import AppList from "@/components/AppList.vue";

export default {
  created() {
    if (!this.vehiclesAreFetchedOnce) {
      this.fetchVehicles();
    }
  },
  components: {
    AppList,
  },
  methods: {
    ...mapActions({
      fetchVehicles: "fetch",
      deleteVehicle: "delete",
      selectYear: "selectYear",
      selectMake: "selectMake",
      selectModel: "selectModel",
      selectEngineSize: "selectEngineSize",
      clearSearch: "clearSearch",
    }),
    ...mapMutations(["SET_PAGE_NUMBER"]),
    deleteClicked(vehicleId) {
      if (window.confirm("Are you sure that you want to delete")) {
        this.deleteVehicle(vehicleId);
      }
    },
    goToSingleItem(vehicleId) {
      this.$router.push({ name: "edit-vehicle", params: { id: vehicleId } });
    },
  },
  computed: {
    ...mapState({
      vehicles: (state) => state.data,
      vehiclesIsLoading: (state) => state.isLoading,
      vehiclesError: (state) => state.error,
      vehicleIsBeingDeletedId: (state) => state.isBeingDeletedId,
      vehiclesAreFetchedOnce: (state) => state.isFetchedOnce,
      years: (state) => state.years,
      selectedYear: (state) => state.selectedYear,
      makes: (state) => state.makes,
      selectedMake: (state) => state.selectedMake,
      models: (state) => state.models,
      selectedModel: (state) => state.selectedModel,
      engineSizes: (state) => state.engineSizes,
      selectedEngineSize: (state) => state.selectedEngineSize,
      pageNumber: (state) => state.pageNumber,
    }),
    ...mapGetters(["filteredItems"]),
  },
};
</script>
